import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomManejoCaja
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0009.8
 **/
class CustomManejoCaja extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                         = this.initForm.bind(this);
        this.gridOptionsComponentes           = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes1          = Object.assign({}, this.gridOptions);
        this.TraerCajas                       = this.TraerCajas.bind(this);
        this.successTraerCajas                = this.successTraerCajas.bind(this);
        this.grabarCaja                       = this.grabarCaja.bind(this);
        this.successGrabarCaja                = this.successGrabarCaja.bind(this);
        this.successExisteCaja                = this.successExisteCaja.bind(this);
        this.successExisteCaja2               = this.successExisteCaja2.bind(this);
        this.ModificarCaja                    = this.ModificarCaja.bind(this);
        this.successModificarCaja             = this.successModificarCaja.bind(this);
        this.mostrarMensajeAdicional          = this.mostrarMensajeAdicional.bind(this);
        this.funcionQueSeEjecutaAlClick       = this.funcionQueSeEjecutaAlClick.bind(this);
        this.habilitarcampos                  = this.habilitarcampos.bind(this);
        this.habilitarcampos1                 = this.habilitarcampos1.bind(this);
        this.deshabilitarcampos               = this.deshabilitarcampos.bind(this);
        this.deshabilitarcampos1              = this.deshabilitarcampos1.bind(this);
        this.setButtonModificar               = this.setButtonModificar.bind(this);
        this.setButtonabrircerrar             = this.setButtonabrircerrar.bind(this);
        this.Modificar                        = this.Modificar.bind(this);
        this.TraerMovimiento                  = this.TraerMovimiento.bind(this);
        this.successTraerMovimiento           = this.successTraerMovimiento.bind(this);
        this.limpiar                          = this.limpiar.bind(this);
        this.modificar                        = false
        this.currencyFormatterGeneral         = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo                = this.formatNumberSaldo.bind(this);
        this.retornarcajas                    = this.retornarcajas.bind(this);
        this.successRetornarCaja              = this.successRetornarCaja.bind(this);
        this.grabarMovimiento                 = this.grabarMovimiento.bind(this);
        this.successGrabarMovimiento          = this.successGrabarMovimiento.bind(this);
        this.id_tab                           = "tab_contenedorDatos";
        this.abrirmodalcaja                   = this.abrirmodalcaja.bind(this);
        this.abrircaja                        = this.abrircaja.bind(this);
        this.successAbrirCaja                 = this.successAbrirCaja.bind(this);
        this.successExisteCajaAbierta         = this.successExisteCajaAbierta.bind(this);
        this.cerrarmodalcaja                  = this.cerrarmodalcaja.bind(this);
        this.TraerSaldoTotal                  = this.TraerSaldoTotal.bind(this);
        this.successTraerSaldoTotal           = this.successTraerSaldoTotal.bind(this);
        this.calcularTotal                    = this.calcularTotal.bind(this);
        this.limpiarcerrar                    = this.limpiarcerrar.bind(this);
        this.cerrarcaja                       = this.cerrarcaja.bind(this);
        this.successcerrarcaja                = this.successcerrarcaja.bind(this);
        this.procesar                         = this.procesar.bind(this);
        this.generarPdf                       = this.generarPdf.bind(this);
        this.isJson                           = this.isJson.bind(this);
        this.mostrarMensajeGenerando          = this.mostrarMensajeGenerando.bind(this);
        this.mostrarMensajeEmailEnviado       = this.mostrarMensajeEmailEnviado.bind(this);
        this.enviarCorreoTerceros             = this.enviarCorreoTerceros.bind(this);
        this.successEnviarCorreo              = this.successEnviarCorreo.bind(this);
        this.generarExcel                     = this.generarExcel.bind(this);
        this.abrirImprimir                    = this.abrirImprimir.bind(this);
        this.TraerSaldoCaja                   = this.TraerSaldoCaja.bind(this);
        this.successTraerSaldoCaja            = this.successTraerSaldoCaja.bind(this);
        this.successTraerSaldoCaja2           = this.successTraerSaldoCaja2.bind(this);
        this.successValidarSaldo              = this.successValidarSaldo.bind(this);
        this.successValidarInactivar          = this.successValidarInactivar.bind(this);
        this.consultar = false;
        this.numero_decimales = 4;
    }

    initForm(){
     
        console.log('Formulario CustomManejoCaja,  @version: jdesk_1.01.0009.8, @author: Patricia Lopez Sanchez');
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;

        this.getField("TabJaivana_" +331).setClickTab(this.funcionQueSeEjecutaAlClick);
        this.getField('usuario2').setValue(this.codigo_usuario);
        this.TraerCajas();
        this.getField('guardar').setClick(()=>{
            if(this.modificar === false){
                this.grabarCaja();
            }else{
                this.ModificarCaja();
            }
        });
        this.getField('cancelar').setClick(this.deshabilitarcampos);
        this.getField('cancelar2').setClick(this.deshabilitarcampos1);
        this.getField('cancelar3').setClick(()=>{
            this.getField('modal_abrir_caja').handleClose();
            this.getField("saldo1").setValue('');
            this.getField("base1").setValue('');
        });
        this.getField('cancelar4').setClick(()=>{
            this.getField('modal_cerrar_caja').handleClose();
            this.limpiarcerrar();
        });
        this.getField('agregar').setClick(()=>{
            this.habilitarcampos();
            this.limpiar();
        });
        this.getField('agregar_movimiento').setClick(this.habilitarcampos1);
        this.getField('crear_movimiento').setClick(this.grabarMovimiento);
        this.getField('abrir_caja').setClick(this.abrircaja);
        this.getField('cerrar_caja').setClick(this.cerrarcaja);

        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} },
        { 'text': 'Ingreso', 'value': 'INGRESO', 'campos_cambian': {} },
        { 'text': 'Egreso', 'value': 'EGRESO', 'campos_cambian': {} }
        ];

        this.getField('tipo').setOptions(opciones);
        this.getField('tipo').setOnChange(()=>{
            if(this.getField('tipo').getValue() === 'EGRESO'){
                if(this.getField("valor").getValue() > 0){
                    this.getField("valor").setValue("-"+this.getField("valor").getValue())
                }
            }else{
                this.getField("valor").setValue(Math.abs(this.getField("valor").getValue()));
                this.getField('valor').setError(false, '');
            }
        });

        this.getField('estadoactivo_id').setOnChange(()=>{
            if(this.modificar === false){
                if(this.getField('estadoactivo_id').getValue() === '1' || this.getField('estadoactivo_id').getValue() === ''){
                    this.getField("base").setDisabled(false) 
                }else if(this.getField('estadoactivo_id').getValue() === '2'){
                    this.getField("base").setValue('0')
                    this.getField("base").setDisabled(true)
                }
            }
        });

        this.getField('categoria').setOnChange(()=>{
            if(this.getField('categoria').getValue() === '7'){
                if(this.getField("valor").getValue() < 0){
                    this.getField('valor').setError(true, 'Si la categoria es base caja el valor no puede ser negativo.', 'error');
                }
                if(this.getField('tipo').getValue() === 'EGRESO'){
                    this.getField('tipo').setError(true, 'Si la categoria es base caja el tipo no puede ser un egreso.');
                }else{
                    this.getField('tipo').setError(false, '');
                }
            }else{
                this.getField('valor').setError(false, '');
                this.getField('tipo').setError(false, '');
            }
        });

        this.getField('ch_base').setOnChange((props) => {
            if (this.getField('ch_base').getValue() === 'false') {
                this.getField('base_final').setVisible(true);                
            } else {
                this.getField('base_final').setVisible(false);
                this.getField('base_final').setValue('');
            }
        });

        this.getField("exportar").setClick(()=>{
            if(this.getField('cajas').getValue() > 0){
                this.abrirImprimir()
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar una caja especifica.', 'error');
            }
        });
        this.getField('generar_archivo').setClick(()=>this.procesar());
        this.getField('modal_imprimir').setCloseButton(()=>{
            this.initForm();
        });

        this.getField('modal_cerrar_caja').setCloseButton(()=>{
            this.limpiarcerrar();
        });
        
        this.getField('efectivo').setOnChange(this.calcularTotal);
        this.getField('transferencia').setOnChange(this.calcularTotal);
        this.getField('consignacion').setOnChange(this.calcularTotal);
        this.getField('cheque').setOnChange(this.calcularTotal);
        this.getField('bono').setOnChange(this.calcularTotal);
        this.getField('tarjeta_credito').setOnChange(this.calcularTotal);
        this.getField('tarjeta_debito').setOnChange(this.calcularTotal);
        this.getField('otros').setOnChange(this.calcularTotal);
        this.getField('anticipo_caja').setOnChange(this.calcularTotal);
        this.getField('base_final').setOnChange(()=>{
            if(this.getField('base_final').getValue() > this.getField('efectivo').getValue()){
                this.getField('base_final').setError(true,'La base debe ser menor o igual al efectivo.')
            }
        });

        this.getField('ch_excel').setOnChange((props)=>{
            if(this.getField('ch_excel').getValue()==='false'){
                this.getField('ch_pdf').setValueSwitch (false);
                this.operacion_actual='excel';
            }
        });

        this.getField('ch_pdf').setOnChange((props)=>{
            if(this.getField('ch_pdf').getValue()==='false'){
                this.getField('ch_excel').setValueSwitch (false);
                this.operacion_actual='pdf';
            }
        });

        this.getField('radio_correo').setOnChange((props) => {
            if (this.getField('radio_correo').getValue() === 'N') {
                this.getField('email').setDisabled(true);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            } else {
                this.getField('email').setDisabled(false);
                this.getField('email').setValue('');
                this.getField('email').setError(false, '');
            }
        });
    }

    habilitarcampos(){
        this.getField('codigo_sucursal').setVisible(true);
        this.getField('nombre_sucursal').setVisible(true);
        this.getField('nombre_usuario').setVisible(true);
        this.getField('codigo_facturacion').setVisible(true);
        this.getField('nombre').setVisible(true); 
        this.getField('estadoactivo_id').setVisible(true);
        this.getField('usuario').setVisible(true);
        this.getField('base').setVisible(true);
        this.getField('guardar').setVisible(true);
        this.getField('cancelar').setVisible(true);
        this.getField('agregar').setVisible(false);

        this.getField('codigo_sucursal').setError(false,'');
        this.getField('nombre_sucursal').setError(false,'');
        this.getField('nombre_usuario').setError(false,'');
        this.getField('codigo_facturacion').setError(false,'');
        this.getField('usuario').setError(false,'');
        this.getField('base').setError(false,'');
        this.getField('nombre').setError(false,'');
        this.getField('estadoactivo_id').setError(false,'');
    }

    deshabilitarcampos(){
        this.getField('codigo_sucursal').setVisible(false);
        this.getField('nombre_sucursal').setVisible(false);
        this.getField('nombre_usuario').setVisible(false);
        this.getField('codigo_facturacion').setVisible(false);
        this.getField('nombre').setVisible(false);
        this.getField('estadoactivo_id').setVisible(false);
        this.getField('base').setVisible(false);
        this.getField('usuario').setVisible(false);
        this.getField('guardar').setVisible(false);
        this.getField('cancelar').setVisible(false);

        this.getField('codigo_sucursal').setValue('');
        this.getField('nombre_sucursal').setValue('');
        this.getField('nombre_usuario').setValue('');
        this.getField('codigo_facturacion').setValue('');
        this.getField('nombre').setValue('');
        this.getField('estadoactivo_id').setValue('');
        this.getField('usuario').setValue('');
        this.getField('base').setValue('');

        this.getField('codigo_sucursal').setDisabled(false);
        this.getField('nombre_sucursal').setDisabled(false);
        this.getField('nombre_usuario').setDisabled(false);
        this.getField('codigo_facturacion').setDisabled(false);
        this.getField('usuario').setDisabled(false);
        this.getField('base').setDisabled(false);

        this.getField('agregar').setVisible(true);
    }

    limpiar(){
        this.getField('codigo_sucursal').setValue('');
        this.getField('nombre_sucursal').setValue('');
        this.getField('nombre_usuario').setValue('');
        this.getField('codigo_facturacion').setValue('');
        this.getField('nombre').setValue('');
        this.getField('estadoactivo_id').setValue('');
        this.getField('base').setValue('');

        this.getField('cajas_id').setValue('');
        this.getField('codigo_sucursal2').setValue('');
        this.getField('nombre_sucursal2').setValue('');
        this.getField('codigo_facturacion2').setValue('');
        this.getField('valor').setValue('');
        this.getField('estado').setValue('');
        this.getField('detalle').setValue('');
        this.getField('tipo').setValue('');
        this.getField('categoria').setValue('');
        this.getField('formas_pago').setValue('');
        this.getField('numero_referencia').setValue('');

        this.getField('codigo_sucursal').setError(false,'');
        this.getField('nombre_sucursal').setError(false,'');
        this.getField('nombre_usuario').setError(false,'');
        this.getField('codigo_facturacion').setError(false,'');
        this.getField('nombre').setError(false,'');
        this.getField('estadoactivo_id').setError(false,'');
        this.getField('base').setError(false,'');

        this.getField('cajas_id').setError(false,'');
        this.getField('codigo_sucursal2').setError(false,'');
        this.getField('nombre_sucursal2').setError(false,'');
        this.getField('codigo_facturacion2').setError(false,'');
        this.getField('valor').setError(false,'');
        this.getField('estado').setError(false,'');
        this.getField('detalle').setError(false,'');
        this.getField('tipo').setError(false,'');
        this.getField('categoria').setError(false,'');
        this.getField('formas_pago').setError(false,'');
        this.getField('numero_referencia').setError(false,'');
    }

    limpiarcerrar(){
        this.getField('efectivo').setValue(0);
        this.getField('efectivo_tabla').setValue(0);
        this.getField('transferencia').setValue(0);
        this.getField('transferencia_tabla').setValue(0);
        this.getField('consignacion').setValue(0);
        this.getField('consignacion_tabla').setValue(0);
        this.getField('cheque').setValue(0);
        this.getField('cheque_tabla').setValue(0);
        this.getField('bono').setValue(0);
        this.getField('bono_tabla').setValue(0);
        this.getField('tarjeta_credito_tabla').setValue(0);
        this.getField('tarjeta_credito').setValue(0);
        this.getField('tarjeta_debito_tabla').setValue(0);
        this.getField('tarjeta_debito').setValue(0);
        this.getField('otros').setValue(0);
        this.getField('otros_tabla').setValue(0);
        this.getField('anticipo_caja').setValue(0);
        this.getField('anticipo_caja_tabla').setValue(0);
        this.getField('saldo_total').setValue(0);
        this.getField('valor_caja_tabla').setValue(0);
        this.getField('valor_caja_digitado').setValue(0);
        this.getField('diferencia').setValue(0);
        this.getField('base_final').setValue(0);

        this.getField('efectivo').setError(false,'');
        this.getField('efectivo_tabla').setError(false,'');
        this.getField('transferencia').setError(false,'');
        this.getField('transferencia_tabla').setError(false,'');
        this.getField('consignacion').setError(false,'');
        this.getField('consignacion_tabla').setError(false,'');
        this.getField('cheque').setError(false,'');
        this.getField('cheque_tabla').setError(false,'');
        this.getField('bono').setError(false,'');
        this.getField('bono_tabla').setError(false,'');
        this.getField('tarjeta_credito_tabla').setError(false,'');
        this.getField('tarjeta_credito').setError(false,'');
        this.getField('tarjeta_debito_tabla').setError(false,'');
        this.getField('tarjeta_debito').setError(false,'');
        this.getField('otros').setError(false,'');
        this.getField('otros_tabla').setError(false,'');
        this.getField('anticipo_caja').setError(false,'');
        this.getField('anticipo_caja_tabla').setError(false,'');
        this.getField('saldo_total').setError(false,'');
        this.getField('valor_caja_tabla').setError(false,'');
        this.getField('valor_caja_digitado').setError(false,'');
        this.getField('diferencia').setError(false,'');
        this.getField('base_final').setError(false,'');

        this.getField("cajas_id").setValue('');
        this.getField("codigo_sucursal").setValue('');
        this.getField("codigo_facturacion").setValue('');
        this.getField('base_final').setVisible(false);

        this.getField('ch_base').setValue(false)
    }

    TraerCajas(){
        let datos={ datos: {}};
        this.getField("tabla_cajas").setTipoServicioOperacion("fact-manejocaja-traercajas");
        this.getField("tabla_cajas").sendRequest(this.successTraerCajas, datos);
    }

    successTraerCajas(data){
        if(data.estado_p===200){

            let configCell = new Map();
            configCell.set('fecha', { 
                cellRenderer: (props) => {
                    const fechaOriginal = props.data.fecha; 
                    let fechaModificada = fechaOriginal.replace("T", " "); 
                    let fechaObjeto = new Date(fechaModificada);

                    let segundos = fechaObjeto.getSeconds();

                    let fechaFormateada = fechaObjeto.toISOString().split('T')[0] + ' ' + 
                          fechaObjeto.toTimeString().split(' ')[0].slice(0, -3) + 
                          ':' + segundos.toString().padStart(2, '0');
                    
                    return fechaFormateada;
                }
            });

            this.gridOptionsComponentes['rowData'] = data.data;
            configCell.set('modificar', { cellRenderer: this.setButtonModificar, width: 110, sortable: false, filter: false, field: 'Modificar' });
            configCell.set('abrir/cerrar', { cellRenderer: this.setButtonabrircerrar, width: 110, sortable: false, filter: false, field: 'abrir/cerrar' });
            this.getField('tabla_cajas').initData(this.gridOptionsComponentes, configCell);
            this.getField('tabla_cajas').toggle(true);
            this.deshabilitarcampos();          

        }else {
            if(data.estado_p===404) {
                this.getField('tabla_cajas').toggle(false);
                this.habilitarcampos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        }
    }

    setButtonModificar(props) {
        if(props.data.id !== "."){
            let id = props.data.id;
            let button = document.createElement("input");
            button.onclick = () => this.Modificar(props.data);
            button.setAttribute("id", 'button_delete_' + id);
            button.setAttribute("class", "buttonStyle");
            button.setAttribute("type", "button");
            button.setAttribute("value", "modificar");
            return this.createElementJaivana(button);
        }
    }

    setButtonabrircerrar(props) {
        if (props.data.id !== ".") {
            let id = props.data.id;
            let data = props.data;

            let button = document.createElement("input");
            button.setAttribute("id", 'button_delete_' + id);
            button.setAttribute("class", "buttonStyle");
            button.setAttribute("type", "button");

            if (props.data.estado === 0) {
                button.setAttribute("value", "ABRIR CAJA");
                button.onclick = () => this.abrirmodalcaja(data); 
            } else if (props.data.estado === 1) {
                button.setAttribute("value", "CERRAR CAJA");
                button.onclick = () => this.cerrarmodalcaja(data); 
            }

            return this.createElementJaivana(button);
        }
    }

    Modificar(data) {
        this.id = data.id;
        this.datoscaja= data;
        this.modificar = true;
        this.habilitarcampos();
        this.getField('codigo_sucursal').setDisabled(true);
        this.getField('nombre_sucursal').setDisabled(true);
        this.getField('nombre_usuario').setDisabled(true);
        this.getField('codigo_facturacion').setDisabled(true);
        this.getField('usuario').setDisabled(true);
        this.getField('base').setDisabled(true);

        this.getField('codigo_sucursal').setValue(data.codigo_sucursal);
        this.getField('nombre_sucursal').setValue(data.nombre_sucursal);
        this.getField('codigo_facturacion').setValue(data.codigo_facturacion);
        this.getField('nombre').setValue(data.nombre);
        this.getField('estadoactivo_id').setValue(data.estadoactivo_id);
        this.getField('base').setValue(data.base);
        this.getField('usuario').setValue(data.usuario);
        this.getField('nombre_usuario').setValue(data.nombre_usuario);
    }

    
    grabarCaja(){
        if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() && this.getField("codigo_facturacion").valid()
        && this.getField("nombre").valid() && this.getField("estadoactivo_id").valid() && this.getField("base").valid()  && this.getField("usuario").valid() && this.getField("nombre_usuario").valid()){

            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);

            let datos={ datos: {
                codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                nombre: this.getField("nombre").getValue().replace(/\s+/g, '')
            }};
    
            this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: '20', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successExisteCaja,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
            });
        }else{
            this.getField('confirmModalCustom').toggle(false);
            this.alertGeneral.toggle(true, 'Debe diligenciar todos los campos o corregir los errores de los campos.', 'error');
        }
    }


    successExisteCaja(data){
        if (data.estado_p === 200 )
        {  
            this.getField('confirmModalCustom').toggle(false); 
            this.alertGeneral.toggle(true, 'Ya existe una caja con el mismo nombre asociada a esta sucursal '+this.getField("codigo_sucursal").getValue()+' - '+this.getField("nombre_sucursal").getValue()+' y codigo de facturación '+this.getField("codigo_facturacion").getValue(), 'error');
        }else if (data.estado_p === 404 ){
            if(parseInt(this.getField("estadoactivo_id").getValue())=== 1){
                let datos={ datos: {
                    cajas_id:0,
                    estado:parseInt(this.getField("estadoactivo_id").getValue()),
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue()
                }};
        
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'validarinactivar', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successValidarInactivar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }else{
                let datos = { datos: {
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    estado: parseInt(this.getField("estadoactivo_id").getValue()),
                    usuario: this.getField("usuario").getValue(),
                    usuario1: this.getField("usuario2").getValue(),
                    base: this.getField("base").getValue()
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_caja', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successGrabarCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        } else {
            this.getField('confirmModalCustom').toggle(false); 
        }
    }

    successGrabarCaja(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.deshabilitarcampos();
            this.TraerCajas();
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    ModificarCaja(){
        if(this.datoscaja.nombre.replace(/\s+/g, '') !== this.getField("nombre").getValue().replace(/\s+/g, '')){
            if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() && this.getField("codigo_facturacion").valid()
            && this.getField("nombre").valid() && this.getField("estadoactivo_id").valid() && this.getField("usuario").valid() && this.getField("nombre_usuario").valid()){
    
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
    
                let datos={ datos: {
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue().replace(/\s+/g, '')
                }};
        
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: '20', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successExisteCaja2,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }else{
                this.getField('confirmModalCustom').toggle(false);
                this.alertGeneral.toggle(true, 'Debe diligenciar todos los campos ', 'error');
            }
        }else{
            if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() && this.getField("codigo_facturacion").valid()
            && this.getField("nombre").valid() && this.getField("estadoactivo_id").valid() && this.getField("usuario").valid() && this.getField("nombre_usuario").valid()){
    
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);

                let datos={ datos: {
                    cajas_id:this.id,
                    estado:parseInt(this.getField("estadoactivo_id").getValue()),
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                }};
        
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'validarinactivar', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successValidarInactivar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }else{
                this.getField('confirmModalCustom').toggle(false);
                this.alertGeneral.toggle(true, 'Debe diligenciar todos los campos ', 'error');
            }
        }
    }

    successExisteCaja2(data){
        if (data.estado_p === 200 )
        {  
            this.getField('confirmModalCustom').toggle(false); 
            this.alertGeneral.toggle(true, 'Ya existe una caja con el mismo nombre asociada a esta sucursal '+this.getField("codigo_sucursal").getValue()+' - '+this.getField("nombre_sucursal").getValue()+' y codigo de facturación '+this.getField("codigo_facturacion").getValue(), 'error');
        }else if (data.estado_p === 404 ){
            if(this.getField("estadoactivo_id").getValue()===2){
                let datos={ datos: {
                   cajas_id:this.id
                }};
        
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'validarinactivar', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successValidarInactivar,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }else{
                let datos = { datos: {
                    id:this.id,
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    estado: parseInt(this.getField("estadoactivo_id").getValue())
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'modificar_caja', operacion_tipo: 'modificar' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successModificarCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        } else {
            this.getField('confirmModalCustom').toggle(false); 
        }
    }

    successValidarInactivar(data){
        if (data.estado_p === 200 )
        {    
            if(this.modificar){
                let datos = { datos: {
                    id:this.id,
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    estado: parseInt(this.getField("estadoactivo_id").getValue())
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'modificar_caja', operacion_tipo: 'modificar' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successModificarCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }else{
                 let datos = { datos: {
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    estado: parseInt(this.getField("estadoactivo_id").getValue()),
                    usuario: this.getField("usuario").getValue(),
                    usuario1: this.getField("usuario2").getValue(),
                    base: this.getField("base").getValue()
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_caja', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successGrabarCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        }else{
            this.getField('confirmModalCustom').toggle(false); 
            if(data.data.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje);
        }
    }

    successModificarCaja(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.modificar=false;
            this.deshabilitarcampos();
            this.TraerCajas();
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    funcionQueSeEjecutaAlClick(event,newValue){
        this.limpiar()
        if(newValue === 0 && this.id_tab !== event){
            this.id_tab = event
            this.TraerCajas();
            this.deshabilitarcampos();
        }
        else if(newValue === 1 && this.id_tab !== event){
            this.id_tab = event;
            this.retornarcajas();
            this.deshabilitarcampos1();  
            this.getField("saldo").setValue(0); 
            this.getField("cajas").setValue('');
            this.getField("consultar").setClick(this.TraerMovimiento);
            this.getField("cajas").setOnChange(()=>{
                this.getField("saldo").setValue(0);
                this.gridOptionsComponentes['rowData'] = [];
                this.getField('tabla_movimientos').toggle(false);
                this.deshabilitarcampos1();   
            });
        }
    }

    /////////////MOVIMIENTO////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    
    retornarcajas(){
        let datos={ datos: {}};
        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'retornarcajas', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successRetornarCaja,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successRetornarCaja(data){
        if(data.estado_p===200){
            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }]

            opciones.push({
                'text': 'Todas',
                'value': '0',
                'campos_cambian': {}
            });

            data.data.forEach(caja => {
                opciones.push({
                    'text': caja.nombre, 
                    'value': caja.id, 
                    'campos_cambian': {} 
                });
            });

            let opciones1 = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.nombre;
                dataOp['campos_cambian'] = {codigo_sucursal2 :item.codigo_sucursal,nombre_sucursal2:item.nombre_sucursal,codigo_facturacion2:item.codigo_facturacion,estado:item.estado };
                opciones1.push(dataOp);
            });
            
            this.getField('cajas_id').setOptions(opciones1);             
            this.getField('cajas').setOptions(opciones);             
        }else {
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'Error no existen cajas creadas.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        }
    }

    habilitarcampos1(){
        this.getField('cajas_id').setVisible(true);
        this.getField('codigo_sucursal2').setVisible(true);
        this.getField('nombre_sucursal2').setVisible(true);
        this.getField('codigo_facturacion2').setVisible(true);
        this.getField('estado').setVisible(true);
        this.getField('valor').setVisible(true);
        this.getField('detalle').setVisible(true);
        this.getField('tipo').setVisible(true);
        this.getField('categoria').setVisible(true);
        this.getField('formas_pago').setVisible(true);
        this.getField('numero_referencia').setVisible(true);
        this.getField('cajas_id').setValue('');
        this.getField('codigo_sucursal2').setValue('');
        this.getField('nombre_sucursal2').setValue('');
        this.getField('codigo_facturacion2').setValue('');
        this.getField('estado').setValue('');
        this.getField('valor').setValue('');
        this.getField('detalle').setValue('');
        this.getField('tipo').setValue('');
        this.getField('categoria').setValue('');
        this.getField('formas_pago').setValue('');
        this.getField('numero_referencia').setValue('');
        this.getField('usuario2').setVisible(true);
        this.getField('crear_movimiento').setVisible(true);
        this.getField('cancelar2').setVisible(true);
        this.getField('agregar_movimiento').setVisible(false);
        this.getField('exportar').setDisabled(true);
    }

    deshabilitarcampos1(){
        this.getField('cajas_id').setValue('');
        this.getField('codigo_sucursal2').setValue('');
        this.getField('nombre_sucursal2').setValue('');
        this.getField('codigo_facturacion2').setValue('');
        this.getField('valor').setValue('');
        this.getField('estado').setValue('');
        this.getField('detalle').setValue('');
        this.getField('tipo').setValue('');
        this.getField('categoria').setValue('');
        this.getField('formas_pago').setValue('');
        this.getField('numero_referencia').setValue('');

        this.getField('cajas_id').setVisible(false);
        this.getField('codigo_sucursal2').setVisible(false);
        this.getField('nombre_sucursal2').setVisible(false);
        this.getField('codigo_facturacion2').setVisible(false);
        this.getField('valor').setVisible(false);
        this.getField('detalle').setVisible(false);
        this.getField('estado').setVisible(false);
        this.getField('tipo').setVisible(false);
        this.getField('categoria').setVisible(false);
        this.getField('formas_pago').setVisible(false);
        this.getField('numero_referencia').setVisible(false);
        this.getField('usuario2').setVisible(false);
        this.getField('crear_movimiento').setVisible(false);
        this.getField('cancelar2').setVisible(false);
        this.getField('agregar_movimiento').setVisible(true);
        this.getField('exportar').setDisabled(false);
    }

    TraerMovimiento(){
        this.consultar = true;
        if(this.getField('cajas').valid()){
            this.TraerSaldoCaja();
            let datos={ datos: {}};
            if(this.getField('cajas').getValue() === '0'){
                datos.datos.fecha_desde = this.getField('fecha_desde').getValue(); 
                datos.datos.fecha_hasta = this.getField('fecha_hasta').getValue(); 
                this.getField("tabla_movimientos").setTipoServicioOperacion("fact-manejocaja-traermovimiento");
                this.getField("tabla_movimientos").sendRequest(this.successTraerMovimiento, datos);
            }else{
                datos.datos.cajas = this.getField('cajas').getValue(); 
                datos.datos.fecha_desde = this.getField('fecha_desde').getValue(); 
                datos.datos.fecha_hasta = this.getField('fecha_hasta').getValue(); 
                this.getField("tabla_movimientos").setTipoServicioOperacion("fact-manejocaja-traermovimiento1");
                this.getField("tabla_movimientos").sendRequest(this.successTraerMovimiento, datos);
            }
        }else{
            this.alertGeneral.toggle(true, 'Debe seleccionar una caja o en su defecto seleccionar todas.', 'error');
        }
        
    }

    successTraerMovimiento(data){
        if(data.estado_p===200){
            let configCell = new Map();
            configCell.set('valor', { 
                cellRenderer: (props) => {return this.currencyFormatterGeneral(props.data.valor);},
                cellStyle: function (props){
                    if(props.data.tipo === 'INGRESO')
                        return { textAlign: "right", borderRadius: "5px", color: 'rgba(243, 239, 239, 1)',backgroundColor: '#56a14cff', fontWeight: 'bold' }
                    else
                        return { textAlign: "right", borderRadius: "5px", color: 'rgba(247, 241, 241, 1)',backgroundColor: '#a32e2eff', fontWeight: 'bold' }
                },    
                width: 110
            });

            configCell.set('fecha', { 
                cellRenderer: (props) => {
                    const fechaOriginal = props.data.fecha;  
                    let fechaObjeto = new Date(fechaOriginal);
                    let fechaFormateada = fechaObjeto.toLocaleString('sv-SE').split('T')[0] + ' ';
                    
                    return fechaFormateada;
                }
            });

            this.gridOptionsComponentes1['rowData'] = data.data;
            this.getField('tabla_movimientos').initData(this.gridOptionsComponentes1, configCell);
            this.getField('tabla_movimientos').toggle(true);
            this.deshabilitarcampos1();          

        }else {
            if(data.estado_p===404) {
                this.getField('tabla_movimientos').toggle(false);
                this.getField("saldo").setValue(0);
                this.habilitarcampos1();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        }
    }

    grabarMovimiento(){
        if(this.getField("cajas_id").valid() && this.getField("codigo_sucursal2").valid() && this.getField("nombre_sucursal2").valid() && this.getField("codigo_facturacion2").valid()
        && this.getField("valor").valid() && this.getField("detalle").valid() && this.getField("tipo").valid() && this.getField("categoria").valid()
        && this.getField("formas_pago").valid() && this.getField("numero_referencia").valid() && this.getField("usuario2").valid()){

            if(this.getField("valor").getValue() !== 0){
                if(this.getField('tipo').getValue() === 'EGRESO'){
                    if(this.getField("valor").getValue() > 0){
                        this.getField("valor").setValue("-"+this.getField("valor").getValue())
                    }
                }else{
                    this.getField("valor").setValue(Math.abs(this.getField("valor").getValue()));
                }
                let error = 0;
                if(this.getField('categoria').getValue() === '7'){
                    if(this.getField("valor").getValue() < 0){
                        this.getField('valor').setError(true, 'Si la categoria es base caja el valor no puede ser negativo.', 'error');
                        error++;
                    }
                    if(this.getField('tipo').getValue() === 'EGRESO'){
                        this.getField('tipo').setError(true, 'Si la categoria es base caja el tipo no puede ser un egreso.');
                        error++;
                    }else{
                        this.getField('tipo').setError(false, '');
                        this.getField('valor').setError(false, '');
                    }
                }

                if(error === 0){
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
        
                    if(this.getField('tipo').getValue() === 'EGRESO'){
                        let datos = { datos: {
                            cajas_id: this.getField("cajas_id").getValue(),
                            valor: this.getField("valor").getValue(),
                            formas_pago: this.getField("formas_pago").getValue(),
                        }};
                    
                        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'traer_saldo_forma_pago', operacion_tipo: 'consulta' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'GET',
                            body: datos,
                            success: this.successValidarSaldo,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }else{
                        let datos = { datos: {
                            cajas_id: this.getField("cajas_id").getValue(),
                            codigo_sucursal2: this.getField("codigo_sucursal2").getValue(),
                            codigo_facturacion2: this.getField("codigo_facturacion2").getValue(),
                            valor: this.getField("valor").getValue(),
                            detalle: this.getField("detalle").getValue().replace(/<[^>]+>/g, ''),
                            tipo: this.getField("tipo").getValue(),
                            categoria: this.getField("categoria").getValue(),
                            formas_pago: this.getField("formas_pago").getValue(),
                            numero_referencia: this.getField("numero_referencia").getValue(),
                            usuario2: this.getField("usuario2").getValue()
                        }};
                    
                        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_movimiento', operacion_tipo: 'crear' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'POST',
                            body: datos,
                            success: this.successGrabarMovimiento,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }
                }
            }else{
                this.alertGeneral.toggle(true, 'El valor no puede estar en 0.', 'error');
            }
        }else{
            this.getField('confirmModalCustom').toggle(false);
            this.alertGeneral.toggle(true, 'Debe diligenciar todos los campos ', 'error');
        }
    }

    successValidarSaldo(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            let datos = { datos: {
                cajas_id: this.getField("cajas_id").getValue(),
                codigo_sucursal2: this.getField("codigo_sucursal2").getValue(),
                codigo_facturacion2: this.getField("codigo_facturacion2").getValue(),
                valor: this.getField("valor").getValue(),
                detalle: this.getField("detalle").getValue().replace(/<[^>]+>/g, ''),
                tipo: this.getField("tipo").getValue(),
                categoria: this.getField("categoria").getValue(),
                formas_pago: this.getField("formas_pago").getValue(),
                numero_referencia: this.getField("numero_referencia").getValue(),
                usuario2: this.getField("usuario2").getValue()
            }};
        
            this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'grabar_movimiento', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarMovimiento,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.mostrarMensajeAdicional(data.data.mensaje);
        }
    }

    successGrabarMovimiento(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {   
            let hoy= new Date();
            let dia=hoy.getDate();
            let mes=hoy.getMonth()+1;
            let año=hoy.getFullYear();
            if(mes<10){
                mes='0'+mes;
            }
            if(dia<10){
                dia='0'+dia;
            }
            this.getField("fecha_hasta").setValue(año+'-'+mes+'-'+dia);
            this.getField("cajas").setValue(this.getField("cajas_id").getValue());
            this.TraerMovimiento();
            this.deshabilitarcampos1();
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    abrirImprimir(){
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
    }

    procesar(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'){
            if(this.getField('email').valid()===false){
                errores++;
            }
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_pdf').getValue()==='false'){
            errores++;
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: PDF o Excel.', 'error');
        }

        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoTerceros();
                }else{
                    if(this.operacion_actual==='pdf'){
                        this.generarPdf();
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcel();
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }

    
    enviarCorreoTerceros(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            cajas: parseInt(this.getField("cajas").getValue()),
            email: this.getField('email').getValue(),
            radio_correo: this.getField('radio_correo').getValue(),
            fecha_desde: this.getField('fecha_desde').getValue(),
            fecha_hasta: this.getField('fecha_hasta').getValue(),
            operacion: this.operacion_actual
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'imprimir', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    successEnviarCorreo(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeEmailEnviado();
        }else if(data.estado_p ===404){
            this.mostrarMensajeNoHayDatos();
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    generarPdf(){       

        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2={
            cajas: parseInt(this.getField("cajas").getValue()),
            email: this.getField('email').getValue(),
            fecha_desde: this.getField('fecha_desde').getValue(),
            fecha_hasta: this.getField('fecha_hasta').getValue(),
            radio_correo: this.getField('radio_correo').getValue(),
            operacion: this.operacion_actual
        }

        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"fact-manejocaja","operacion":"imprimir","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        .then(response => {
        this.getField('confirmModalCustom').toggle(false);
        if(response.status!==200){
        return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                    }else{
                        const pdf = new File([blob], 'movimiento_caja.pdf', {
                            type:'application/pdf'});
                        window.open(URL.createObjectURL(pdf));
                    } 
                });
            }else{
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.alertGeneral.toggle(true,err,'error');
        });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }


    generarExcel()
    {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2={
            cajas: parseInt(this.getField("cajas").getValue()),
            email: this.getField('email').getValue(),
            fecha_desde: this.getField('fecha_desde').getValue(),
            fecha_hasta: this.getField('fecha_hasta').getValue(),
            radio_correo: this.getField('radio_correo').getValue(),
            operacion: this.operacion_actual
        }

        const myJSON = JSON.stringify(datos2);
        let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"fact-manejocaja","operacion":"imprimir","operacion_tipo":"consulta"}}';
        fetch(url+datos,{
        method:'GET', 
        headers:new Headers({
                "Authorization": 'Bearer '+localStorage.getItem('token'), 
                "Content-Type":'application/json'})})
        .then(response => {
        this.getField('confirmModalCustom').toggle(false);
        if(response.status!==200){
            return '';
        }
        const reader = response.body.getReader();
        return new ReadableStream({
        start(controller) {
        return pump();
        function pump() {
                return reader.read().then(({ done, value }) => {
                if (done) {
                    controller.close();
                    return;}
                controller.enqueue(value);
                return pump();});}}})})
        .then(stream => new Response(stream))
        .then(response => response.blob())
        .then(blob => {
            if(blob.size>0){
                blob.text().then(res=>{
                    if(this.isJson(res)){
                        this.successEnviarCorreo(JSON.parse(res));
                    }else{
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = 'MovimientosCaja.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        alert('Se descargo el archivo!');
                    } 
                });
            }else{
                this.mostrarMensajeNoHayDatos();
            }
        }).catch(err => {
            this.alertGeneral.toggle(true,err,'error');
        });
    }

    ////////////////ABRIR CAJA /////////////////////////////////////////////////////////////////////////////////////////////////

    abrirmodalcaja(data){
        if(data.estado_activo === 'Activo'){
            this.getField("cajas_id").setValue(data.id);
            this.TraerSaldoCaja();
            this.getField("modal_abrir_caja").handleClickOpen();
            this.getField("modal_abrir_caja").setLabel('Abrir '+data.nombre);
        }else{
            this.mostrarMensajeAdicional('La caja esta inactiva, para abrirla primero debe activarla.');
        }
    }

    TraerSaldoCaja(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere. `);
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

        if(this.consultar){
            let datos={ datos: {
                fecha_desde :this.getField('fecha_desde').getValue(),
                fecha_hasta :this.getField('fecha_hasta').getValue()
            }};
            if(this.getField('cajas').getValue() !== '0'){
                datos.datos.cajas = this.getField('cajas').getValue(); 
            }
            this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'traer_saldo_caja', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successTraerSaldoCaja2,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
            });
        }else{
            let datos={ datos: {
                cajas_id: this.getField("cajas_id").getValue()
            }};
    
            this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'traer_saldo_caja', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successTraerSaldoCaja,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
            });
        }
    }
    
    successTraerSaldoCaja(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.getField("saldo1").setValue(this.currencyFormatterGeneral(data.data.total));
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }    
    
    successTraerSaldoCaja2(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {   
            this.consultar = false;
            this.getField("saldo").setValue(this.currencyFormatterGeneral(data.data.total));
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }    

    abrircaja(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere. `);
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

        let datos={ datos: {
            codigo_sucursal: this.getField("codigo_sucursal").getValue(),
            codigo_facturacion: this.getField("codigo_facturacion").getValue()
        }};

        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: '1_4', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successExisteCajaAbierta,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successExisteCajaAbierta(data){
        if (data.estado_p === 200 )
        {    
            this.getField('confirmModalCustom').toggle(false); 
            this.alertGeneral.toggle(true, 'Ya existe una caja abierta para este codigo de sucursal '+this.getField("codigo_sucursal").getValue()+' - '+this.getField("nombre_sucursal").getValue()+' y codigo de facturación '+this.getField("codigo_facturacion").getValue(), 'error');
        }else{
            if(this.getField("base1").getValue() > 0){

                let datos = { datos: {
                    id:this.getField("cajas_id").getValue(),
                    base1: this.getField("base1").getValue(),
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    usuario2: this.getField("usuario2").getValue()
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'abrir_caja', operacion_tipo: 'modificar' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successAbrirCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }else{
                let datos = { datos: {
                    id:this.getField("cajas_id").getValue(),
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    nombre: this.getField("nombre").getValue(),
                    usuario2: this.getField("usuario2").getValue()
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'abrir_caja', operacion_tipo: 'modificar' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successAbrirCaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        }
    }
    
    successAbrirCaja(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.getField('modal_abrir_caja').handleClose();
            this.getField("saldo1").setValue('');
            this.getField("base1").setValue('');
            this.deshabilitarcampos();
            this.TraerCajas();
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    ////////////////////////////// CERRAR CAJA ////////////////////////////////////////////////////////////////////

    cerrarmodalcaja(data){
        this.getField('ch_base').setValue('false')
        this.getField("base_final").setVisible(false);
        this.getField("cajas_id").setValue(data.id);
        this.getField("codigo_sucursal").setValue(data.codigo_sucursal);
        this.getField("codigo_facturacion").setValue(data.codigo_facturacion);
        this.TraerUltimoCierre(data);

        this.getField("modal_cerrar_caja").handleClickOpen();
        this.getField("modal_cerrar_caja").setLabel('Cerrar '+data.nombre);
    }

    TraerUltimoCierre(data){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere. `);
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let datos={ datos: {
            cajas_id: data.id
        }};

        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: '1_5', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.TraerSaldoTotal,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    TraerSaldoTotal(data){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere. `);
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let datos={};

        if(data.estado_p === 200){
            datos={ datos: {
                cajas_id: this.getField("cajas_id").getValue(),
                value: data.data[0].fecha_cierre
            }};
        }else{
            datos={ datos: {
                cajas_id: this.getField("cajas_id").getValue()
            }};
        }

        this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: '1_6', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerSaldoTotal,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successTraerSaldoTotal(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            let total = 0;

            const formasDePago = [
                "efectivo", "transferencia", "consignacion", "cheque", 
                "bono", "tarjeta credito", "tarjeta debito", "otros", "anticipo caja"
            ];

            data.data.data.forEach(item => {
                if (formasDePago.includes(item.forma_pago)) {
                    this.getField(item.forma_pago.replace(' ', '_') + '_tabla').setValue(item.total_forma_pago);
                    
                    total += parseFloat(item.total_forma_pago);
                }
            });

            formasDePago.forEach(formaPago => {
                const campoValor = this.getField(formaPago.replace(' ', '_') + '_tabla').getValue();
                if (isNaN(campoValor) || campoValor === '') {
                    this.getField(formaPago.replace(' ', '_') + '_tabla').setValue(0);
                }
            });

            formasDePago.forEach(formaPago => {
                this.getField(formaPago.replace(' ', '_')).setValue(0);
            });

            this.getField('valor_caja_tabla').setValue(total.toFixed(2));
            this.getField("saldo_total").setValue(this.currencyFormatterGeneral(total));
        }else{
            this.getField("saldo_total").setValue(0);
            this.getField("valor_caja_digitado").setValue(0);
            this.getField("valor_caja_tabla").setValue(0);
            this.getField("diferencia").setValue(0);
            this.getField("saldo_total").setValue(0);
            this.getField("base_final").setValue(0)
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    calcularTotal(){
        const formasDePago = [
            "efectivo", "transferencia", "consignacion", "cheque", 
            "bono", "tarjeta credito", "tarjeta debito", "otros", "anticipo caja"
        ];

        let total = 0;

        formasDePago.forEach(formaPago => {
            const campoValor = parseInt(this.getField(formaPago.replace(' ', '_')).getValue());
            if (isNaN(campoValor)) {
                total += 0; 
            } else {
                total += campoValor;
            }
        });

        this.getField('valor_caja_digitado').setValue(total.toFixed(2));

        let diferencia = this.getField('valor_caja_digitado').getValue() - this.getField('valor_caja_tabla').getValue();
        this.getField('diferencia').setValue(diferencia.toFixed(2));
        
        let efectivo = this.getField('efectivo').getValue() - this.getField('efectivo_tabla').getValue();
        this.getField('diferencia_efectivo').setValue(efectivo.toFixed(2));
        
        let transferencia = this.getField('transferencia').getValue() - this.getField('transferencia_tabla').getValue();
        this.getField('diferencia_transferencia').setValue(transferencia.toFixed(2));
        
        let consignacion = this.getField('consignacion').getValue() - this.getField('consignacion_tabla').getValue();
        this.getField('diferencia_consignacion').setValue(consignacion.toFixed(2));
        
        let bono = this.getField('bono').getValue() - this.getField('bono_tabla').getValue();
        this.getField('diferencia_bono').setValue(bono.toFixed(2));
        
        let cheque = this.getField('cheque').getValue() - this.getField('cheque_tabla').getValue();
        this.getField('diferencia_cheque').setValue(cheque.toFixed(2));
        
        let tarjeta_credito = this.getField('tarjeta_credito').getValue() - this.getField('tarjeta_credito_tabla').getValue();
        this.getField('diferencia_tarjeta_credito').setValue(tarjeta_credito.toFixed(2));
        
        let tarjeta_debito = this.getField('tarjeta_debito').getValue() - this.getField('tarjeta_debito_tabla').getValue();
        this.getField('diferencia_tarjeta_debito').setValue(tarjeta_debito.toFixed(2));
        
        let otros = this.getField('otros').getValue() - this.getField('otros_tabla').getValue();
        this.getField('diferencia_otros').setValue(otros.toFixed(2));
        
        let anticipo = this.getField('anticipo_caja').getValue() - this.getField('anticipo_caja_tabla').getValue();
        this.getField('diferencia_anticipo_caja').setValue(anticipo.toFixed(2));

    }

    cerrarcaja(){
        if(this.getField('efectivo').valid() && this.getField('transferencia').valid() && this.getField('consignacion').valid() && this.getField('bono').valid()
         && this.getField('cheque').valid() && this.getField('tarjeta_credito').valid() && this.getField('tarjeta_debito').valid() && this.getField('otros').valid()
         && this.getField('anticipo_caja').valid()){

            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere. `);
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
            
            if(this.getField('base_final').getValue() > this.getField('efectivo').getValue()){
                this.getField('confirmModalCustom').toggle(false);
                this.getField('base_final').setError(true,'La base debe ser menor o igual al efectivo.')
                this.alertGeneral.toggle(true, 'La base debe ser menor o igual al efectivo.', 'error');
            }else{
                const formasDePago = [
                    "efectivo", "transferencia", "consignacion", "cheque", 
                    "bono", "tarjeta credito", "tarjeta debito", "otros", "anticipo caja"
                ];
        
                let valoresFormasDePago = {};
                let diferenciasFormasDePago = {};
        
                formasDePago.forEach(formaPago => {
                    const campoValor = this.getField(formaPago.replace(' ', '_')).getValue();
                    const campoValor1 = this.getField("diferencia_"+formaPago.replace(' ', '_')).getValue();
                    
                    valoresFormasDePago[formaPago] = campoValor;
                    diferenciasFormasDePago[formaPago] = campoValor1;
                });
    
                let datos = { datos: {
                    cajas_id: this.getField("cajas_id").getValue(),
                    codigo_sucursal: this.getField("codigo_sucursal").getValue(),
                    codigo_facturacion: this.getField("codigo_facturacion").getValue(),
                    valor_caja_digitado: this.getField("valor_caja_digitado").getValue(),
                    valor_caja_tabla: this.getField("valor_caja_tabla").getValue(),
                    base_final: this.getField("base_final").getValue(),
                    diferencia: this.getField("diferencia").getValue(),
                    diferencias: diferenciasFormasDePago,
                    formas_de_pago: valoresFormasDePago,
                    usuario2: this.getField("usuario2").getValue()
                }};
            
                this.generalFormatPmv = { tipo_servicio: 'fact-manejocaja', operacion: 'cierre_caja', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successcerrarcaja,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        }
    }

    successcerrarcaja(data){
        this.getField('confirmModalCustom').toggle(false); 
        if (data.estado_p === 200 )
        {    
            this.getField('modal_cerrar_caja').handleClose();
            this.limpiarcerrar();
            this.TraerCajas();
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
 
    mostrarMensajeEmailEnviado(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

}
FormJaivana.addController("fact-manejocaja",CustomManejoCaja);
export default CustomManejoCaja